module.exports = __webpack_public_path__ + "img/vue.d887c91d.svg";